var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".user_svg__st0{fill:none;stroke:#231f20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "user_svg__st0",
    cx: 24.6,
    cy: 18.4,
    r: 7.4,
    id: "user_svg__Layer_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_svg__Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "user_svg__st0",
    d: "M14.6 37c0-6.3 4.4-11.4 9.9-11.4M34.2 37c0-6.3-4.3-11.4-9.7-11.4"
  }))))));
};
export default SvgUser;